// @flow strict
import * as React from 'react'
import cx from 'classnames'

import {
  type PropsWithChildren,
  type Obj,
} from '@mondough/public-web-components'
import styles from './TriptychSection.module.scss'
import { SectionWrapper, SectionThemes } from './SectionWrapper'
import SubtitleSection from './SubtitleSection'
import { MarkdownContent } from './MarkdownContent'

export type TriptychSectionProps = {|
  sections: {
    title: string,
    text: string,
    iconURL?: string,
    imageURL?: string,
  }[],
  reverse: boolean,
  flags?: Obj<string, string>,
  className?: string,
  direction?: 'vertical' | 'horizontal',
|}

const Triptych = ({
  sections,
  reverse,
  className = '',
  children,
}: PropsWithChildren<
  TriptychSectionProps,
  React.Element<typeof SubtitleSection>,
>) => (
  <SectionWrapper
    theme={SectionThemes.LIGHT}
    className={reverse ? styles.reverseSection : undefined}
    contentClassName={cx(styles.baseContent, { [className]: className !== '' })}
  >
    {children}
    <div className={styles.centerContentWrapper}>
      {sections
        .filter(({ title, text }) => title != null && text != null)
        .map(({ title, text, iconURL }) => {
          return (
            <div className={styles.column} key={title}>
              {iconURL && <img alt="" src={iconURL} className={styles.icon} />}
              {children ? (
                <h3 className={styles.title}>{title}</h3>
              ) : (
                <h2 className={styles.title}>{title}</h2>
              )}
              <MarkdownContent className={styles.copy}>{text}</MarkdownContent>
            </div>
          )
        })}
    </div>
  </SectionWrapper>
)

export default Triptych
